import {Component, OnInit} from '@angular/core';
import {Room, RoomService} from "../../../services/room.service";
import {ActivatedRoute, Router} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {UserService} from "../../../services/user.service";
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import {Role, RoleService} from "../../../services/role.service";

@Component({
    selector: 'app-join-room',
    templateUrl: './join-room.component.html',
    styleUrls: ['./join-room.component.scss'],
    standalone: true,
    imports: [NgIf, MatButtonModule]
})
export class JoinRoomComponent implements OnInit {

  loading: boolean = true ;
  room?: Room ;
  role?: Role ;

  constructor(
    public rooms: RoomService,
    public roles: RoleService,
    public route: ActivatedRoute,
    public router: Router
  ) {

  }

  async ngOnInit() {

    this.loading = true ;

    const roomId = this.route.snapshot.params['roomId'] ;

    try {
      this.room = await firstValueFrom(this.rooms.getRoom(roomId)) ;
      this.role = await firstValueFrom(this.roles.getMyRoomRole(roomId)) ;

      if (!this.role) {
        await this.joinRoom();
      }

      this.loading = false ;
    }
    catch (e) {
      console.log(e) ;
      this.loading = false ;
    }
  }

  public async joinRoom() {
    await this.router.navigate(['rooms', this.room!.id]) ;
  }

  public async controlRoom() {
    await this.router.navigate(['admin','control-room', this.room!.id]) ;
  }
}
